import * as types from '../actions/actionTypes'

export const initialState = {
  sdkLoaded: false,
  currentOrder: null,
}

export default function tapPayReducer(tapPay = initialState, action) {
  switch (action.type) {
    case types.CHECKOUT_TAPPAY_SUCCESS:
    case types.CHECKOUT_TAPPAY_INSTALMENT_SUCCESS:
    case types.CHECKOUT_TAPPAY_PERIODIC_SUCCESS:
      return {
        ...tapPay,
        currentOrder: action.payload,
      }
    case types.CHECKOUT_TAPPAY_ERROR:
    case types.CHECKOUT_TAPPAY_INSTALMENT_ERROR:
    case types.CHECKOUT_TAPPAY_PERIODIC_ERROR:
      return {
        ...tapPay,
        currentOrder: {
          error: true,
          failed: action.payload.failed,
          errno: action.payload.errno,
          stayAtPurchase: action.payload.stayAtPurchase,
        },
      }
    case types.CLEAR_PURCHASE_RESULT:
      return {
        ...tapPay,
        currentOrder: null,
      }
    case types.LOAD_TAPPAY_SDK_SUCCESS:
      return {
        ...tapPay,
        sdkLoaded: true,
      }
    case types.LOAD_TAPPAY_SDK_ERROR:
      return {
        ...tapPay,
        sdkLoaded: 'error',
      }
    default:
      return tapPay
  }
}
